<template>
  <v-dialog v-model="dialog.show" max-width="900" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col v-if="radioForm == 1" cols="6">
              <SelectEquipesBySupervisor @onChanged="colaboradores = $event; changeSelectEquipe()" />
            </v-col>
            <v-col v-if="radioForm == 1" cols="6">
              <SelectColaboradoresByEquipe
                @onChanged="lead.donoDoLead = $event"
                label="Colaborador"
                :colaboradores="colaboradores"
                :disabled="disableSelectColaboradores"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="lead.nome" :rules="[rules.required]" label="Nome"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="lead.celular"
                v-mask="'(##)#####-####'"
                :rules="[rules.required]"
                label="Celular"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="lead.comentarios" label="Comentarios"></v-text-field>
            </v-col>
            <v-col cols="6">
              <DateMenu label="Data Proximo Contato" @onChanged="lead.dataProxContato = $event" />
            </v-col>
            <v-col cols="6">
              <SelectFormaPagamento @onChanged="lead.formaDePagamento = $event" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Veiculo"
                @click="$refs.dialogSelectVeiculos.show()"
                v-model="lead.nomeVeiculo"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-radio-group v-model="radioForm" row>
          <v-radio label="Para mim" :value="0"></v-radio>
          <v-radio label="Para outro" :value="1"></v-radio>
        </v-radio-group>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
    <DialogSelectVeiculos ref="dialogSelectVeiculos" @selected="setSelectedVeiculo($event)" />
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import rules from "@/utils/rules";
import { Vendedor } from "@/services/lead";

export default {
  name: "DialogFormCreate",

  components: {
    DateMenu: () => import("@/components/datepicker/DateMenu"),
    DialogSelectVeiculos: () => import("../../components/DialogSelectVeiculos"),
    SelectFormaPagamento: () => import("../../components/SelectFormaPagamento"),
    SelectEquipesBySupervisor: () => import("./SelectEquipesBySupervisor"),
    SelectColaboradoresByEquipe: () => import("./SelectColaboradoresByEquipe")
  },

  data() {
    return {
      radioForm: 0,
      colaboradores: [],
      disableSelectColaboradores: true,
      lead: {
        celular: "",
        comentarios: "",
        dataCriacao: new Date(),
        dataProxContato: new Date(),
        donoDoLead: "",
        empresa: "",
        formaDePagamento: "",
        idVeiculo: "",
        location: {
          latitude: 0,
          longitude: 0
        },
        nome: "",
        nomeVeiculo: "",
        origem: "flyVendas",
        status: "Pendente",
        termometro: "SuperQuente",
        tipoOrigem: "Presencial"
      },
      serviceLeadsVendedor: new Vendedor(),
      dialog: {
        show: false,
        title: "Criar Lead"
      },
      rules
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"])
  },

  methods: {
    show() {
      this.lead.empresa = this.getUser.empresaPrincipal;
      this.getGeoLocation();
      this.dialog.show = true;
    },

    getGeoLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.lead.location.latitude = position.coords.latitude;
          this.lead.location.longitude = position.coords.longitude;
        });
      } else {
        this.$toast.error("Seu navegador não suporta Geolocalização");
      }
    },

    setSelectedVeiculo(veiculo) {
      this.lead.nomeVeiculo = veiculo.descricao;
      this.lead.idVeiculo = veiculo.id;
    },

    getCpfColaborador() {
      const cpf = this.colaboradores.filter(
        colaborador => colaborador.colaborador == this.lead.donoDoLead
      );
      return cpf[0].cpf_completo;
    },

    async save() {
      if (this.$refs.form.validate()) {
        try {
          this.lead.donoDoLead =
            this.radioForm == 0 ? this.getUser.cpf : this.getCpfColaborador();
          await this.serviceLeadsVendedor.create({ ...this.lead });
          this.close();
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao criar Lead");
          return Promise.reject(error);
        }
      }
    },

    close() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.dialog.show = false;
    },

    changeSelectEquipe() {
      this.disableSelectColaboradores = false;
    }
  }
};
</script>
